export default __webpack_public_path__ + "static/media/logo_opalrt.612dd423.svg";